// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash/fp';

// Components
import measurementsConnect from '../../measurementsStore/measurementsConnect';

// Actions
import { markPoisAsSeen } from '../poiActions';

// Utils
import { hasChanged } from '../../../utils/react/propsComparisons';
import {
    getPoiCommentId,
    getPoiElementId,
    getPoiId,
    getPoiIsCommentActivity,
    getPoiIsElementChange,
    getPoiNotificationId,
    getPoiSeen,
    getPoiTargetRect,
} from '../poiSelector';
import { containsRect } from '../../../../common/maths/geometry/rect';
import { markNotificationElementsAsSeen } from '../../../notifications/notificationActions';

const layerRectHasChanged = hasChanged('layerRect');
const pointersHaveChanged = hasChanged('pointers');

const mapDispatchToProps = (dispatch) => ({
    dispatchMarkNotificationElementsAsSeen: (elementViews, commentViews) =>
        dispatch(markNotificationElementsAsSeen({ views: elementViews, commentViews })),
});

const mapMeasurementsDispatchToProps = (dispatch) => ({
    dispatchSeenPois: ({ ids }) => dispatch(markPoisAsSeen({ ids })),
});

export default (DecoratedComponent) => {
    @connect(null, mapDispatchToProps)
    @measurementsConnect(null, mapMeasurementsDispatchToProps)
    class MarkSeenCanvasPointerTargetsDecorator extends React.Component {
        componentDidMount() {
            this.findVisiblePointsOfInterest(this.props);
        }

        componentWillReceiveProps(nextProps) {
            if (pointersHaveChanged(this.props, nextProps) || layerRectHasChanged(this.props, nextProps)) {
                return this.findVisiblePointsOfInterest(nextProps);
            }
        }

        findVisiblePointsOfInterest = (props) => {
            const { pointers, layerRect, dispatchSeenPois, dispatchMarkNotificationElementsAsSeen } = props;

            if (!layerRect) return;

            const isWithinViewLayer = containsRect(layerRect);

            const elementViews = [];
            const commentViews = [];
            const seenPoiIds = pointers.reduce((acc, pointer) => {
                const pointerId = getPoiId(pointer);

                const targetRect = getPoiTargetRect(pointer);

                if (!getPoiSeen(pointer) && isWithinViewLayer(targetRect)) {
                    acc.push(pointerId);

                    if (getPoiIsElementChange(pointer)) {
                        elementViews.push({
                            elementId: getPoiElementId(pointer) || getPoiCommentId(pointer),
                            notificationId: getPoiNotificationId(pointer),
                        });
                    } else if (getPoiIsCommentActivity(pointer)) {
                        commentViews.push({
                            commentId: getPoiCommentId(pointer),
                            notificationId: getPoiNotificationId(pointer),
                        });
                    }
                }

                return acc;
            }, []);

            if (!isEmpty(seenPoiIds)) {
                dispatchSeenPois({ ids: seenPoiIds });
            }

            if (!isEmpty(elementViews) || !isEmpty(commentViews)) {
                dispatchMarkNotificationElementsAsSeen(elementViews, commentViews);
            }
        };

        render() {
            return <DecoratedComponent {...this.props} />;
        }
    }

    MarkSeenCanvasPointerTargetsDecorator.propTypes = {
        layerRect: PropTypes.object.isRequired,
        pointers: PropTypes.array,
        dispatchSeenPois: PropTypes.func,
        dispatchMarkNotificationElementsAsSeen: PropTypes.func,
    };

    return MarkSeenCanvasPointerTargetsDecorator;
};
